import { render, staticRenderFns } from "./listMessage.vue?vue&type=template&id=659e61b2"
import script from "./listMessage.vue?vue&type=script&lang=js"
export * from "./listMessage.vue?vue&type=script&lang=js"
import style0 from "./listMessage.vue?vue&type=style&index=0&id=659e61b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports